document.addEventListener('click', function (e) {
    const fila = e.target.closest('.trSelectAlmacenado');
    if (!fila) return;

    const idAlmacenado = fila.dataset.id;
    const idReporte    = fila.dataset.idReporte;

    const inputId      = document.getElementById('idLineaEntregaPaquetesAlmacenadosEditar');
    const inputReporte = document.getElementById('idReporteSopladoEditarAlmacenado');

    if (inputId)      inputId.value      = idAlmacenado;
    if (inputReporte) inputReporte.value = idReporte;

    fetch(`/api/soplado/info-entrega-almacenado?idLine=${idAlmacenado}`, {
        method: 'GET',
        credentials: 'include'
    })
    .then(r => r.json())
    .then(json => {
        const d = Array.isArray(json.result) ? json.result[0] : json.result;
        if (!d) return;

        const elBodega = document.getElementById('idBodegaEditar');
        const elCant   = document.getElementById('cantPaquetesAlmacenadoEditar');
        const elUnd    = document.getElementById('cantUnidadesAlmacenadoEditar');

        if (elBodega) elBodega.value = d.idBodega ?? '';
        if (elCant) {
            const paq = d.cantPaquetes != null ? Number(d.cantPaquetes) : 0;
            const unidadEmpaque = d.unidadEmpaque != null ? Number(d.unidadEmpaque) : 140;
            elCant.value = new Intl.NumberFormat('en-US').format(paq);
            if (elUnd) elUnd.value = new Intl.NumberFormat('en-US').format(paq * unidadEmpaque);
        }
    })
    .catch(err => console.error('Error al cargar almacenado:', err));
});

document.addEventListener('submit', function (e) {
    const form = e.target.closest('#formEditarAlmacenadoSoplado');
    if (!form) return;
    e.preventDefault();

    modal = form.closest('.modal');
    
    const btnSubmit = form.querySelector('[type="submit"]');
    if (btnSubmit) btnSubmit.disabled = true;

    const data = new FormData(form);

    fetch('/api/soplado/editar-entrega-almacenado', {
        method: 'POST',
        credentials: 'include',
        body: data
    })
    .then(r => r.json())
    .then(json => {
        const resultado = json.result ? json.result : {};
        const errores = resultado.errores ?? [];
        errores.forEach(e => {
            lanzarAlerta(e.mensaje, e.clase);
            const campo = form.querySelector('[name="' + e.campo + '"]');
            if (campo) campo.classList.add('inputRojo');
        });

        if (!resultado.hayErrores) {
            const idReporte = document.getElementById('idReporteSopladoEditarAlmacenado').value;
            form.reset();
            modal.classList.remove('modal--show');
            if (idReporte && typeof window.actualizarTablaAlmacenado === 'function') {
                window.actualizarTablaAlmacenado(idReporte);
            }
            if (typeof window.actualizarModalReporteSoplado === 'function') {
                window.actualizarModalReporteSoplado(idReporte);
            }
            lanzarAlerta('Entrega almacenada editada correctamente.', 'alerta-verde');
        }
    })
    .catch(() => lanzarAlerta('Error al conectar con el servidor.', 'alerta-roja'))
    .finally(() => { if (btnSubmit) btnSubmit.disabled = false; });
});
